import { render, staticRenderFns } from "./ActivityTimeline.vue?vue&type=template&id=57cadccc&"
import script from "./ActivityTimeline.vue?vue&type=script&lang=js&"
export * from "./ActivityTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cadccc')) {
      api.createRecord('57cadccc', component.options)
    } else {
      api.reload('57cadccc', component.options)
    }
    module.hot.accept("./ActivityTimeline.vue?vue&type=template&id=57cadccc&", function () {
      api.rerender('57cadccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/ActivityTimeline.vue"
export default component.exports